export const SET_SUPPORT_COUNTER_AMOUNT = 'SET_SUPPORT_COUNTER_AMOUNT';